<!-- eslint-disable max-len -->
<template>
  <v-layout fluid v-resize="updateDataTableHeight">
<!--    <access-modal />-->
    <v-snackbar
      :timeout="-1"
      :value="exportSuccess"
      bottom
      right
      style="margin-bottom: 30px"
    >
      Report will be emailed to you shortly...
      <v-btn
        style="margin-left: 18px !important"
        color="warning"
        dark
        small
        @click="dismissNotif"
      >
        Dismiss
      </v-btn>
    </v-snackbar>
    <v-snackbar
      :timeout="-1"
      :value="exportFailed"
      bottom
      right
      style="margin-bottom: 30px"
    >
      Your report download has failed. Please contact necessary personal...
      <v-btn
        style="margin-left: 18px !important"
        color="warning"
        dark
        small
        @click="dismissNotif"
      >
        Dismiss
      </v-btn>
    </v-snackbar>
    <div class="dashboard-content">
      <div class="dashboard-leftMenu">
        <Meetings :summary="isBetBack" :loading="meetingsLoading" :meetings="data" :viewSetting="viewSetting" :viewType="viewType" :updateDataTableHeight="updateDataTableHeight"/>
      </div>
      <div class="dashboard-rightMenu">
        <BookieList
          :meeting="selectedMeeting || {}"
          :race="selectedRace || {}"
          :bookiesrace="bookiesrace"
          :items="bookies"
          :isDeveloper="isDeveloper"
          :darkMode="darkMode"
          :toggleAccessModal="toggleAccessModal"
          :logout="logout"
          :viewType="viewType"
          :updateDataTableHeight="updateDataTableHeight"
        />
      </div>
<!--      <div class="dashboardBookies mt-2">-->
<!--        <BetDetails-->
<!--          :meeting="selectedMeeting || {}"-->
<!--          :race="selectedRace || {}"-->
<!--          :bookiesrace="bookiesrace"-->
<!--          :items="bookies"-->
<!--          :isDeveloper="isDeveloper"-->
<!--          :darkMode="darkMode"-->
<!--          :toggleAccessModal="toggleAccessModal"-->
<!--          :logout="logout"-->
<!--        />-->
<!--      </div>-->
      <div v-show="viewType === 'detailedView'" class="dashboardTables" ref="dashboardTables">
        <DetailedView :dataTableHeight="dataTableHeight"/>
      </div>
      <div v-show="viewType === 'overView'" class="dashboardTables">
        <Summary :viewType="viewType"/>
      </div>
    </div>
  </v-layout>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { format } from 'date-fns'
import Meetings from '../components/Meetings'
import DetailedView from '../components/DetailedView'
import Summary from '../components/Summary'
import BookieList from '../components/BookieList'
import { loaders } from '../store'

export default {
  name: 'dashboard',
  data () {
    return {
      format,
      isBetBack: false,
      allRaces: true,
      dataTableHeight: 0,
      showRunner: true,
      showMeeting: false,
      viewType: 'detailedView'
    }
  },
  mounted () {
    // this.fetchBookieRace()
    // this.fetchAllRaces()
    this.fetchCountryRaces()
  },
  components: {
    Meetings,
    BookieList,
    DetailedView,
    Summary
  },
  watch: {
    selectedDate () {
      this.$store.commit('clearRunners')
    },
    selectedCountry () {
      // Enable when BE has filtering
      // this.fetchBookieBetsCountry()
    },
    selectedState () {
      // Enable when BE has filtering
      // this.fetchBookieBetsCountry()
    },

    getDates () {
      // this.clearSelections()
      // this.updateAllRaces(true)
      // this.fetchBookieBets()
      // this.fetchAllBookies()
      // this.fetchBookieRace()
      this.fetchCountryRaces()
    }
  },
  methods: {
    ...mapActions(['fetchData', 'fetchAllBookies', 'fetchBookieBetsCountry', 'fetchBetsByCustomer', 'updateAllRaces', 'setDarkMode', 'setSortByBetTime', 'fetchSecondMeetings', 'fetchCountryRaces', 'clearSelections', 'clearSelectedRace', 'setSelectedRunner', 'setSelectedRace', 'fetchBetSummary', 'fetchBetsAll', 'fetchBetsRace', 'fetchBetsMeeting', 'setSelectedFormat', 'exportBets', 'setPage', 'fetchBetsByType', 'fetchRacesDated', 'setSelectedMeeting', 'fetchBookieBets', 'clearSelections', 'clearSelectedRace', 'fetchBookieBetsDated', 'fetchAllRaces', 'setItemsPerPage', 'setError', 'logout', 'fetchBookieRace', 'fetchBetBacks', 'fetchRunners', 'fetchMeetings', 'fetchBookies', 'fetchBets', 'fetchRaces', 'fetchBookieBets', 'toggleAccessModal']),
    getChartColor (betType) {
      switch (betType) {
        case 'win':
          return '#f56a79'
        case 'place':
          return '#1aa6b7'
        default:
          return 'black'
      }
    },
    viewSetting (v) {
      this.viewType = v
      if (this.viewType === 'overView') {
        this.fetchBookieBetsDated()
        this.fetchBetsByCustomer()
        this.fetchBetsByType()
        this.fetchBookieRace()
        this.fetchBookieBets()
      }
    },
    dismissNotif () {
      this.$store.commit('clearExport')
    },
    updateDataTableHeight () {
      const dataTableInt = setInterval(() => {
        if (this.betsByType?.length > 0) {
          const filteredBetTypes = this.betsByType.filter((a) => a.type !== 'win' && a.type !== 'place')
          let totalBetTypes = 140
          filteredBetTypes.forEach(() => {
            totalBetTypes += 32
          })
          this.dataTableHeight = this.$refs.dashboardTables.clientHeight - totalBetTypes
          clearInterval(dataTableInt)
        }
      }, 200)
    },
    darkMode () {
      let mode
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      if (this.darkModeST === 'light') {
        mode = 'dark'
      } else {
        mode = 'light'
      }
      this.setDarkMode(mode)
    }
  },
  computed: {
    ...mapState(['error', 'betsByType', 'darkModeST', 'user', 'exportSuccess', 'selectedCountry', 'selectedState', 'exportFailed', 'runners', 'access', 'data', 'dateOf', 'loggedIn', 'selectedMeeting', 'bookiesrace', 'selectedRunner', 'betbacks', 'filteredBetBacks', 'selectedRace', 'selectedBookie', 'selectedDate', 'bookies', 'bets', 'races', 'secondRaces', 'filteredBets', 'loading']),
    ...mapGetters(['getPagination', 'getSelectedRace', 'getSelectedMeeting', 'getSelections', 'getDates', 'getDatesFormatted']),
    meetingsLoading () {
      return this.loading[loaders.MEETINGS]
    },
    isDeveloper () {
      return this.access.role === 'DEVELOPER'
    },
    betsLoading () {
      return this.loading[loaders.BETS]
    },
    selectedBetContext () {
      // eslint-disable-next-line camelcase
      const betCtx = `${this.selectedMeeting?.track || this.selectedRace?.track || ''} ${this.selectedRace?.race_number ? `Race ${this.selectedRace.race_number}` : ''} ${this.selectedRunner?.name ? `- Runner: ${this.selectedRunner.name}` : ''}`.trim()
      return betCtx.length > 0 ? `Showing all bets for ${betCtx}` : `Showing all bets for ${this.getDates.join(' ~ ')}`
    },
    selectedBetContextRace () {
      // eslint-disable-next-line camelcase
      const betCtx = `${this.selectedMeeting?.track || this.selectedRace?.track || ''} ${this.selectedRace?.race_number ? `Race ${this.selectedRace.race_number}` : ''}`.trim()
      return betCtx.length > 0 ? `Showing all bets for ${betCtx}` : `Showing all bets for ${this.getDates.join(' ~ ')}`
    },
    selectedBetContextMeeting () {
      // eslint-disable-next-line camelcase
      const betCtx = `${this.selectedMeeting?.track || this.selectedRace?.track || ''}`.trim()
      return betCtx.length > 0 ? `Showing all bets for ${betCtx}` : `Showing all bets for ${this.getDates.join(' ~ ')}`
    },
    selectedBetContextTotal () {
      return `${this.getDatesFormatted.join(' ~ ')}`
    },
    race () {
      return this.getSelectedRace || {}
    },
    meeting () {
      return this.getSelectedMeeting || {}
    }
  }
}
</script>

<style scoped>
.spacer {
  height: 20px
}
.toolbar {
  grid-area: toolbar;
}
.dashboardTables {
  padding-top: 5px;
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
  overflow-y: hidden;
  overflow-x: hidden;
}
.dashboard {
  display: grid;
  grid-template-rows: 70px auto;
  grid-template-columns: auto;
  grid-template-areas:
    "content";
}
.dashboard-header {
  grid-area: header;
}
.dashboard-content {
  display: grid;
  height:100vh;
  width:100%;
  /*padding-right:15px;*/
  grid-template-columns: 270px auto 200px;
  grid-template-rows: 55px auto 10px;
}
.dashboardBookies {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 2;
}
.dashboard-error {
  grid-area: error;
}
.dashboard-topMenu {
  grid-area: topMenu;
}
.dashboard-searchbar {
  grid-area: searchbar;
}
.dashboard-leftMenu {
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 3;
  padding-bottom: 50px;
}
.dashboard-rightMenu {
  grid-column-start: 3;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
}
.dashBoardSummary {
  grid-column-start: 2;
  grid-column-end: 4;
  grid-row-start: 1;
  grid-row-end: 3;
}
.dashboard-centerContent {
  grid-area: centerContent;
}
</style>
